import React from "react";

import { Button, HStack, Icon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import { FiCheckCircle, FiXCircle } from "./modalFieldIcons";
import { usePropertyModalTheme } from "./usePropertyModalTheme";

export default function ModalFooterActions({
	onCancel,
	onConfirm,
	cancelLabel,
	confirmLabel,
	isLoading = false,
	isDisabled = false,
	confirmIcon = FiCheckCircle,
	confirmColorScheme = "blue",
	showCancel = true,
}) {
	const { t } = useTranslation();
	const { borderColor } = usePropertyModalTheme();

	return (
		<HStack spacing={3} w="full" justify="flex-end" borderTop="1px" borderColor={borderColor} pt={3} pb={4} px={6}>
			{showCancel && (
				<Button isDisabled={isLoading || isDisabled} leftIcon={<Icon as={FiXCircle} />} variant="outline" onClick={onCancel} size="sm">
					{cancelLabel || t("misc.cancel")}
				</Button>
			)}
			{onConfirm && (
				<Button
					colorScheme={confirmColorScheme}
					leftIcon={<Icon as={confirmIcon} />}
					onClick={onConfirm}
					isLoading={isLoading}
					isDisabled={isDisabled}
					size="sm"
					px={6}
				>
					{confirmLabel || t("misc.save")}
				</Button>
			)}
		</HStack>
	);
}
